/**
* @class Initializes the s-curve with default sharpness = 2
* @member toxi
*/
var SigmoidInterpolation = function SigmoidInterpolation(s) {
  if (s === undefined) {
    s = 2.0;
  }

  this.setSharpness(s);
};

var _interpolate = function interpolate(a, b, f, sharpness) {
  f = (f * 2 - 1) * sharpness;
  f = 1.0 / (1.0 + Math.exp(-f));
  return a + (b - a) * f;
};

SigmoidInterpolation.prototype = {
  getSharpness: function getSharpness() {
    return this.sharpness;
  },
  interpolate: function interpolate(a, b, f) {
    return _interpolate(a, b, f, this.sharpPremult);
  },
  setSharpness: function setSharpness(s) {
    this.sharpness = s;
    this.sharpPremult = 5 * s;
  }
};
SigmoidInterpolation.interpolate = _interpolate;
module.exports = SigmoidInterpolation;